import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import Link from '../../Link'

export const SocialMediaMenuEntry = styled.li`
  display: block;
  margin-left: 12px;
  position: relative;
  &:last-child {
    margin-right: 12px;
  }
`

export const SocialMediaMenuLink = styled(Link)`
  // increase specificity to override footer link styles
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.colors.coolGray.cool500};
    color: ${({ theme }) => theme.colors.coolGray.cool200};
    width: 32px;
    height: 32px;
    border-radius: 50%;
    transition:
      background-color 0.15s ease-in-out,
      color 0.15s ease-in-out,
      border-color 0.15s ease-in-out;
    box-sizing: border-box;

    &:hover {
      background-color: ${({ theme }) => theme.colors.coolGray.cool200};
      color: ${({ theme }) => theme.colors.brandBlue.dark300};
      border-color: ${({ theme }) => theme.colors.brandBlue.dark300};
    }
  }
`

export const SocialMediaMenuIcon = styled(FontAwesomeIcon)`
  display: block;
  // prevent display of oversized icon while loading
  width: 1em;
  height: 1em;
`
